// extracted by mini-css-extract-plugin
export default {"iconButton":"iconSecondary_iconButton__LNtYh8h2"};